module.exports = "\n  <img  src=\"{{params.value}}\" data-hover=\"width\" alt=\"\">\n\n"